import {DEPRECATED_LS_KEYS} from "ui/config";

export function removeDeprecatedLsKeys() {
	for (const key of DEPRECATED_LS_KEYS) {
		if (window.localStorage.getItem(key) !== null) {
			window.localStorage.removeItem(key);
		}
	}
}
